import { Button, ButtonGroup } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

type Variant = 'outlined' | 'contained' | 'text' | undefined;

export const Switcher: React.FC<{
  enable?: boolean | null;
  onToggle?: (enabled: boolean) => void;
}> = ({ enable = false, onToggle }) => {
  let yesVariant: Variant = 'outlined';
  let noVariant: Variant = 'outlined';

  if (enable !== null) {
    yesVariant = enable ? `contained` : 'outlined';
    noVariant = enable ? `outlined` : 'contained';
  }

  return (
    <ButtonGroup>
      <Button variant={yesVariant} onClick={() => onToggle?.(true)}>
        <FormattedMessage id={'UploadForm.yes'} defaultMessage={'Yes'} />
      </Button>
      <Button variant={noVariant} onClick={() => onToggle?.(false)}>
        <FormattedMessage id={'UploadForm.no'} defaultMessage={'No'} />
      </Button>
    </ButtonGroup>
  );
};
